import { html, css } from 'lit-element';
import { FormElement } from './form-element-base';
import dayjs from 'dayjs';
import '@trumedianetworks/tmn-core-components/src/tmn-input';
import '@trumedianetworks/tmn-core-components/src/tmn-form-group';
import '@trumedianetworks/tmn-core-components/src/date-picker/tmn-date-picker';

const dateFormatFn = (value) => {
    return value && dayjs(value).isValid()
        ? html`${dayjs(value).format('YYYY-MM-DD')}`
        : html`<div>${value}</div>`;
};

class FormElementDate extends FormElement {
    constructor() {
        super();
    }

    static get styles() {
        return [
            ...super.styles,
            css`
                :host {
                    display: flex;
                    flex-flow: column;
                }
                tmn-input {
                    max-width: 300px;
                }
                .normal {
                    font-weight: 500;
                }
            `,
        ];
    }

    render() {
        const { itemTemplate, isOverrideMode, value, validationError, isReadOnly } = this;
        const { isOptional } = itemTemplate;
        const required = !isOptional && !isOverrideMode;
        const displayLabel = this.getDisplayLabel();
        if (this.isViewMode() || isReadOnly) {
            const displayValue = dateFormatFn(value);
            return html`<tmn-form-group>
                <label>${displayLabel}:</label>
                <span>${displayValue}</span>
            </tmn-form-group>`;
        }

        return html`
            <tmn-form-group>
                <label class="normal">${displayLabel}</label>
                <tmn-date-picker
                    .error=${validationError}
                    .value=${value}
                    .monthsDisplayCount=${1}
                    ?disabled=${isReadOnly}
                    .required=${required}
                    @tmn-date-selected=${this.handleSelectDate}
                    @tmn-tool-closed=${this.handleDatePickerClosed}>
                </tmn-date-picker>
            </tmn-form-group>
        `;
    }

    handleSelectDate({ detail }) {
        const { value } = detail;
        const { path } = this;
        this.actions.setStagedEditByPath(path, value);
    }
    // this is really only necessary for being able to clear the date
    handleDatePickerClosed(e) {
        const { path } = this;
        const composedEventPath = e.composedPath() || [];
        const target = composedEventPath[0];
        const value = target.value;
        this.actions.setStagedEditByPath(path, value);
    }
}

customElements.define('form-element-date', FormElementDate);
